<template>
  <div
    v-ripple
    class="calendar-duty-card d-flex flex-column inherit-height"
    :class="isSelected ? 'background darken-2' : ''"
    @click="onSelecteDutyIfExists(duty)"
  >
    <div class="duty-date pt-2" :class="isToday ? 'primary--text' : ''">{{ formattedDutyDate }}</div>
    <div v-if="duty" class="duty-name">{{ duty.dutyname }}</div>
    <div v-if="duty" class="text-white duty-time">{{ dutyTime }}</div>
    <div v-if="duty" class="text-white duty-fromTo">{{ dutyFromTo }}</div>
    <div v-if="!duty" class="duty-name">kein Dienst</div>
  </div>
</template>

<script>
import dateTimeMixin from '@/mixins/dateTimeMixin';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import common from '@/mixins/common';
import dateUtils from '@/common/dateUtils';
import tenantStrategies from '../dutyActivities/tenantStrategies';
import { mapState } from 'vuex';
import MODULE_ID from '@/modules/myDuties/moduleId';

export default {
  mixins: [common, dateTimeMixin, dutyMixin],
  name: 'Calendardutycard',
  props: {
    dutyAndDate: Object,
    selectedDutyId: Number,
    dutiesByDate: Object,
  },

  computed: {
    ...mapState(MODULE_ID, ['dutyActivities', 'dutyStops']),
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    isToday() {
      return dateUtils.isSameDate(this.date, new Date());
    },
    duty() {
      return this.dutyAndDate ? this.dutyAndDate.duty : null;
    },
    isSelected() {
      return this.duty && this.selectedDutyId === this.duty.id;
    },
    date() {
      return this.dutyAndDate ? dateUtils.parseISOString(this.dutyAndDate.date) : null;
    },
    formattedDutyDate() {
      return dateUtils.formatWithShortWeekdayMonthNumber(this.date);
    },
    thisDutyActivities() {
      return this.mx_getDutyActivities(this.duty, { tenant: this.tenant });
    },
    /**
     * Get first activity whose blockcode is not null
     */
    firstActivity() {
      return tenantStrategies.getFirstActivity({
        moduleConfig: this.mx_moduleConfig,
        tenant: this.tenant,
        dutyActivities: this.thisDutyActivities,
      });
    },
    lastActivity() {
      return tenantStrategies.getLastActivity({
        moduleConfig: this.mx_moduleConfig,
        tenant: this.tenant,
        dutyActivities: this.thisDutyActivities,
      });
    },
    dutyFromTo() {
      if (this.duty) {
        let fromTo = '';
        if (this.firstActivity && this.firstActivity.note)
          //{{ dutyActivity.longname }} &nbsp;{{ dutyActivity.note }}
          fromTo += this.firstActivity.note + ' - ';
        if (this.lastActivity && this.lastActivity.note) fromTo += this.lastActivity.note;
        return fromTo;
      }
      return null;
    },
    dutyTime() {
      let time = '';
      if (this.firstActivity && this.firstActivity.fromMinutesAfterMidnight)
        time += this.mx_time(this.firstActivity.fromMinutesAfterMidnight, this.firstActivity) + ' - ';
      if (this.lastActivity && this.lastActivity.toMinutesAfterMidnight) time += this.mx_time(this.lastActivity.toMinutesAfterMidnight, this.lastActivity);
      return time;
    },

    title() {
      return this.duty.title;
    },
  },
  methods: {
    onSelecteDutyIfExists(duty) {
      if (duty) {
        this.$emit('onDutySelected', duty);
      }
    },
  },
};
</script>
<style scoped>
.calendar-duty-card {
  opacity: 0.99;
  width: 100%;
  border-radius: 4px;
}

.duty-date,
.duty-name,
.duty-time {
  font-size: 0.95em;
  text-align: center;
  width: 100%;
}

.duty-date {
  font-weight: bolder;
  font-size: 1.1em;
}

.duty-name {
}

.duty-fromTo {
  font-size: 0.8rem;
}

.duty-time {
  padding-top: 10px;
  font-weight: bold;
}

/* xs -x-small */
@media (max-width: 599px) {
}

/* sm - small */
@media (min-width: 600px) and (max-width: 959px) {
}

/* md - medium */
/* e.g. LVB Tablet 980 x  1650 */
@media (min-width: 960px) and (max-width: 1263px) {
}

/* md - medium */
@media (width: 980px) {
}

/* lg - large */
@media (min-width: 1264px) and (max-width: 1904px) {
}

/* xl - extra large */
@media (min-width: 1905px) {
}
</style>
